import { render, staticRenderFns } from "./AllWalletsPage.vue?vue&type=template&id=3049e112&scoped=true"
import script from "./AllWalletsPage.vue?vue&type=script&lang=js"
export * from "./AllWalletsPage.vue?vue&type=script&lang=js"
import style0 from "./AllWalletsPage.vue?vue&type=style&index=0&id=3049e112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3049e112",
  null
  
)

export default component.exports